export const loadScript = (buildUrl, filename = 'load.js') => {
  const script = document.createElement('script');
  script.src = `${buildUrl}/${filename}`;
  script.async = true;
  document.body.appendChild(script);
};

export default { loadScript };
